import { cloneDeep, has, each } from "lodash";
import StoreManager from "../redux/";
import StorageEngine from "./StorageEngine";
import { Actions } from "../redux/TaskRedux";

const TASKQUEUE_STORAGE_KEY = "TASKQUEUE_STORAGE_KEY";

const TaskTypes = {
    SAVE_UNIT: "SAVE_UNIT",
};

const TaskStates = {
    PENDING: "pending",
    PROCESSING: "processing",
    FAILED: "failed",
};

class TaskHelper {
    constructor(taskType) {
        //load task queue from storage
        let taskQueue = StorageEngine(TASKQUEUE_STORAGE_KEY).load();
        if (taskQueue) {
            each(this.taskQueue, (item) => {
                if (item) {
                    item.isProcessing = false;
                }
            });
            this.taskQueueData = taskQueue;
        } else {
            this.taskQueueData = {};
        }
    }

    saveTaskIntoStorage = (taskQueue) => {
        //save into storage
        StorageEngine(TASKQUEUE_STORAGE_KEY).save(taskQueue);
    };

    /*task = {
        id: "",
        data: "",
        type: TaskTypes.SAVE_UNIT,
        state: TaskStates.PENDING,
        apiMethod: "post",
        error: ""
    }*/
    appendTask = (task) => {
        if (task) {
            if (has(task, "type")) {
                let taskType = task.type;
                if (has(this.taskQueueData, taskType)) {
                    this.taskQueueData[taskType].queue.push(task);
                } else {
                    this.taskQueueData[taskType] = {
                        isProcessing: false,
                        queue: [task],
                    };
                }

                this.saveTaskIntoStorage(this.taskQueueData);
            }
        }
    };

    updateTask = (id, taskType, error) => {
        if (this.taskQueueData && this.taskQueueData[taskType]) {
            let targetQueue = cloneDeep(this.taskQueueData[taskType].queue);
            let taskIndex = targetQueue.findIndex((t) => t.id === id);
            let newTask = cloneDeep(targetQueue[taskIndex]);
            newTask.error = error.message;
            newTask.state = TaskStates.FAILED;
            targetQueue.splice(taskIndex, 1, newTask);
            this.taskQueueData[taskType].queue = targetQueue;
            this.saveTaskIntoStorage(this.taskQueueData);
        }
    };

    removeTaskById = (id, taskType) => {
        if (this.taskQueueData && this.taskQueueData[taskType]) {
            let targetQueue = cloneDeep(this.taskQueueData[taskType].queue);
            targetQueue.findIndex((t) => t.id === id);
            targetQueue.splice(
                targetQueue.findIndex((t) => t.id === id),
                1
            );
            this.taskQueueData[taskType].queue = targetQueue;
            this.saveTaskIntoStorage(this.taskQueueData);
        }
    };

    processTask = (task) => {
        switch (task.type) {
            case TaskTypes.SAVE_UNIT:

            default:
                break;
        }
    };

    getAllTask = () => {
        return StorageEngine(TASKQUEUE_STORAGE_KEY).load() || {};
    };

    clearAllTask = () => {
        this.taskQueueData = {};
        this.saveTaskIntoStorage(this.taskQueueData);
    };

    getPendingTaskByQueueType = (queueType) => {
        if (queueType && has(this.taskQueueData, queueType)) {
            if (this.taskQueueData[queueType] && this.taskQueueData[queueType].queue) {
                return cloneDeep(this.taskQueueData[queueType].queue);
            } else {
                return [];
            }
        } else {
            return [];
        }
    };

    isTaskQueueRunning = (taskType) => {
        if (taskType && has(this.taskQueueData, taskType)) {
            return this.taskQueueData[taskType].isProcessing;
        }
        return false;
    };

    getCurrentExecutingData = () => {
        return cloneDeep(this.taskQueueData);
    };
}

export default new TaskHelper();
export { TaskTypes, TaskStates, TASKQUEUE_STORAGE_KEY };
